import React, { PureComponent } from 'react';
import moment from 'moment';
import { Row, Col, Button } from 'react-bootstrap';

import DocumentosRelacionadosSummary from './DocumentosRelacionadosSummary';

class PagosSummaryItem extends PureComponent {
  handleEdit = () => {
    this.props.onEdit(this.props.index, true);
  };

  handleDelete = () => {
    this.props.onDelete(this.props.index);
  };

  render() {
    const { data, index, count } = this.props;

    return (
      <div className="pb-3">
        <div className="pb-3">
          <strong className="text-upper text-muted">
            Información del pago ({index + 1} de {count})
          </strong>
        </div>

        <Row>
          <Col>
            <strong>
              Fecha de pago:{' '}
              {data.FechaPago ? moment(data.FechaPago, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm') : ''}
            </strong>
            <br />
            Forma de pago: {data.FormaDePagoP}
            <br />
            Moneda: {data.MonedaP}
            <br />
            Tipo de cambio: {data.TipoCambioP}
          </Col>
          <Col>
            <strong>Monto: {data.Monto}</strong>
            <br />
            Número de operación: {data.NumOperacion}
            <br />
            Cuenta ordenante: {data.CtaOrdenante}
            <br />
            Cuenta beneficiario: {data.CtaBeneficiario}
          </Col>
        </Row>

        <DocumentosRelacionadosSummary data={data.DoctoRelacionado} />

        <Row className="pb-3">
          <Col>
            <Button
              variant="secondary"
              size="sm"
              className="mr-2"
              onClick={this.handleEdit}
            >
              Editar
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={this.handleDelete}
            >
              Eliminar
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

class PagosSummary extends PureComponent {
  get data() {
    const { Pago } = this.props.data;

    return !!Pago ? Pago : [];
  }

  renderItem = (item, index) => {
    const { onEdit, onDelete } = this.props;

    return (
      <div key={`pago-summary-${index}`}>
        <PagosSummaryItem
          key={`pago-${index}`}
          data={item}
          index={index}
          count={this.data.length}
          onEdit={onEdit}
          onDelete={onDelete}
        />

        {this.data.length > 1 && <hr key={`he-${index}`} />}
      </div>
    );
  };

  render() {
    const data = this.data;

    return <div className="mt-3">{data.map(this.renderItem)}</div>;
  }
}

export default PagosSummary;
